/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { FormattedNumber } from "react-intl";
import {
  DerivedModifierGroup,
  uniqueModifierKey,
} from "../../hooks/useModifierSelection";

export interface ModifierGroupSelectorProps {
  modifierGroups: DerivedModifierGroup[];
  selectedOptions: any[];
  onModifierSelect: (modifierGroupId: number, modifier: any) => void;
  className?: string;
}

const ModifierGroupSelector: React.FC<ModifierGroupSelectorProps> = ({
  modifierGroups,
  selectedOptions,
  onModifierSelect,
  className = "",
}) => {
  const btnOrangeClass = "btn-orange-toggle";
  const btnWhiteClass = "btn-white";

  const visibleModifierGroups = modifierGroups
    .filter(
      (mg) =>
        mg.visible && mg.modifiers.filter((m: any) => m?.visible).length > 0
    )
    .sort((mg1, mg2) => mg1.displayOrder - mg2.displayOrder);

  return (
    <div className={`modifier-group-selector ${className}`}>
      {visibleModifierGroups.map((modifierGroup) => (
        <div className="modifier-container" key={modifierGroup.id}>
          <label>
            {modifierGroup.name}
            {modifierGroup.minimumChoices > 0 ? "*" : ""}
            {modifierGroup.maximumChoices > 0
              ? ` (max choice: ${modifierGroup.maximumChoices})`
              : ""}
          </label>
          <div className="modifier-buttons">
            {modifierGroup.modifiers
              .sort(
                (a: any, b: any) =>
                  (a?.displayOrder || 0) - (b?.displayOrder || 0)
              )
              .filter((modifier: any) => modifier?.visible)
              .map((modifier: any) => (
                <button
                  key={modifier.id}
                  className={`btn-default btn-modifier ${
                    selectedOptions
                      .map((o) => uniqueModifierKey(o))
                      .includes(uniqueModifierKey(modifier))
                      ? btnOrangeClass
                      : btnWhiteClass
                  }`}
                  onClick={() => onModifierSelect(modifierGroup.id, modifier)}
                >
                  {modifier.name + " "}
                  {modifier.price.amount > 0 ? (
                    <span>
                      {modifier.price.currencySymbol}
                      <FormattedNumber
                        minimumFractionDigits={2}
                        value={modifier.price.amount}
                      />
                    </span>
                  ) : null}
                </button>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ModifierGroupSelector;
